import { render, staticRenderFns } from "./PositionTypesComponent.vue?vue&type=template&id=55c4c170&scoped=true"
import script from "./PositionTypesComponent.vue?vue&type=script&lang=js"
export * from "./PositionTypesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4c170",
  null
  
)

export default component.exports